import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";

const Sidebar = () => {
  const location = useLocation(); // Get the current location
  const [isRecipeOpen, setIsRecipeOpen] = useState(false);
  const [isRecipeMastersOpen, setIsRecipeMastersOpen] = useState(false);
  const [isRestaurantOpen, setIsRestaurantOpen] = useState(false);
  const [isAnalyticsOpen, setIsAnalyticsOpen] = useState(false);
  const [isUserMgtOpen, setIsUserMgtOpen] = useState(false);
  const [isProductMgtOpen, setIsProductMgtOpen] = useState(false);
  const [isCommFeedbackOpen, setIsCommFeedbackOpen] = useState(false);
  const [isContentMgtOpen, setIsContentMgtOpen] = useState(false);

  const handleToggleSidebar = () => {
    // Your toggle sidebar logic here
    window.clickToggleSidebarIcon();
    console.log("Sidebar toggled!");
  };

  return (
    <div className="sidebar" id="main-sidebar" data-background-color="dark">
      <div className="sidebar-logo">
        <div className="logo-header" data-background-color="dark">
          <Link to="/dashboard" className="logo">
            <img
              src="/icon/main-logo.png"
              alt="navbar brand"
              className="navbar-brand"
              loading="lazy"
              height="60"
            />
          </Link>
          <div
            className="nav-toggle cursor-pointer"
            onClick={handleToggleSidebar}
          >
            <button className="btn btn-toggle toggle-sidebar">
              <i className="gg-menu-right"></i>
            </button>
            <button className="btn btn-toggle sidenav-toggler">
              <i className="gg-menu-left"></i>
            </button>
          </div>
          <button className="topbar-toggler more">
            <i className="gg-more-vertical-alt"></i>
          </button>
        </div>
      </div>
      <div className="sidebar-wrapper scrollbar scrollbar-inner">
        <div className="sidebar-content">
          <ul className="nav nav-secondary">
            {/* Dashboard */}
            <li
              className={`nav-item ${
                location.pathname === "/user/dashboard" ? "active" : ""
              }`}
            >
              <Link to="/user/dashboard">
                <i className="fas fa-home"></i>
                <p>Dashboard</p>
              </Link>
            </li>

            {/* Delivery & Pricing Settings */}
            <li
              className={`nav-item ${
                location.pathname === "/user/delivery-pricing" ? "active" : ""
              }`}
            >
              <Link to="/user/delivery-pricing">
                <i className="fas fa-calculator"></i>
                <p>Pricing & Fees</p>
              </Link>
            </li>

            {/* Delivery Shift Gigs */}
            <li
              className={`nav-item ${
                location.pathname === "/user/delivery-gigs" ? "active" : ""
              }`}
            >
              <Link to="/user/delivery-gigs">
                <i className="fas fa-clock"></i>
                <p>Shift Gigs</p>
              </Link>
            </li>

            {/* Restaurant Management Dropdown */}

            <li className="nav-item">
              <a
                href="#!"
                onClick={(e) => {
                  e.preventDefault();
                  setIsRestaurantOpen(!isRestaurantOpen);
                }}
                className={isRestaurantOpen ? "active" : ""}
              >
                <i className="fas fa-store"></i>
                <p>Restaurant Management</p>
                <span className="caret"></span>
              </a>
              {isRestaurantOpen && (
                <div className="collapse show" id="restaurantManagement">
                  <ul className="nav nav-collapse" style={{ paddingLeft: "30px", listStyleType: "none" }}>
                    <li className={location.pathname === "/user/restaurants" ? "active" : ""}>
                      <Link to="/user/restaurants">
                        <span className="sub-item">Restaurants</span>
                      </Link>
                    </li>
                    <li className={location.pathname === "/user/restaurantCity" ? "active" : ""}>
                      <Link to="/user/restaurantCity">
                        <span className="sub-item">Restaurant Cities</span>
                      </Link>
                    </li>
                    <li className={location.pathname.startsWith("/user/partner-applications") ? "active" : ""}>
                      <Link to="/user/partner-applications">
                        <span className="sub-item">Partner Applications</span>
                      </Link>
                    </li>
                    <li className={location.pathname === "/user/restaurant-actions" ? "active" : ""}>
                      <Link to="/user/restaurant-actions">
                        <span className="sub-item">Action Clicks (4 Buttons)</span>
                      </Link>
                    </li>
                  </ul>
                </div>
              )}
            </li>

            {/* Analytics Dropdown */}
            <li className="nav-item">
              <a
                href="#!"
                onClick={(e) => {
                  e.preventDefault();
                  setIsAnalyticsOpen(!isAnalyticsOpen);
                }}
                className={isAnalyticsOpen ? "active" : ""}
              >
                <i className="fas fa-chart-bar"></i>
                <p>Analytics</p>
                <span className="caret"></span>
              </a>
              {isAnalyticsOpen && (
                <div className="collapse show" id="analyticsManagement">
                  <ul className="nav nav-collapse" style={{ paddingLeft: "30px", listStyleType: "none" }}>
                    <li className={location.pathname === "/user/restaurant-actions" ? "active" : ""}>
                      <Link to="/user/restaurant-actions">
                        <span className="sub-item">Restaurant Actions (4 Buttons)</span>
                      </Link>
                    </li>
                    <li className={location.pathname === "/user/restaurant-clicks" ? "active" : ""}>
                      <Link to="/user/restaurant-clicks">
                        <span className="sub-item">Restaurant Clicks</span>
                      </Link>
                    </li>
                    <li className={location.pathname === "/user/product-clicks" ? "active" : ""}>
                      <Link to="/user/product-clicks">
                        <span className="sub-item">Product Clicks</span>
                      </Link>
                    </li>
                    <li className={location.pathname === "/user/recipe-video-clicks" ? "active" : ""}>
                      <Link to="/user/recipe-video-clicks">
                        <span className="sub-item">Recipe Video Clicks</span>
                      </Link>
                    </li>
                    <li className={location.pathname === "/user/recipe-clicks" ? "active" : ""}>
                      <Link to="/user/recipe-clicks">
                        <span className="sub-item">Recipe Clicks</span>
                      </Link>
                    </li>
                    <li className={location.pathname === "/user/nearby-search-clicks" ? "active" : ""}>
                      <Link to="/user/nearby-search-clicks">
                        <span className="sub-item">Nearby Search Clicks</span>
                      </Link>
                    </li>
                  </ul>
                </div>
              )}
            </li>

            {/* User Management Dropdown */}
            <li className="nav-item">
              <a
                href="#!"
                onClick={(e) => {
                  e.preventDefault();
                  setIsUserMgtOpen(!isUserMgtOpen);
                }}
                className={isUserMgtOpen ? "active" : ""}
              >
                <i className="fas fa-users"></i>
                <p>User Management</p>
                <span className="caret"></span>
              </a>
              {isUserMgtOpen && (
                <div className="collapse show" id="userManagement">
                  <ul className="nav nav-collapse" style={{ paddingLeft: "30px", listStyleType: "none" }}>
                    <li className={location.pathname === "/user/users" ? "active" : ""}>
                      <Link to="/user/users">
                        <span className="sub-item">Users</span>
                      </Link>
                    </li>
                    <li className={location.pathname === "/user/contributions" ? "active" : ""}>
                      <Link to="/user/contributions">
                        <span className="sub-item">Contributions</span>
                      </Link>
                    </li>
                    <li className={location.pathname === "/user/like/dislike" ? "active" : ""}>
                      <Link to="/user/like/dislike">
                        <span className="sub-item">Like and Dislike</span>
                      </Link>
                    </li>
                  </ul>
                </div>
              )}
            </li>

            {/* Product Management Dropdown */}
            <li className="nav-item">
              <a
                href="#!"
                onClick={(e) => {
                  e.preventDefault();
                  setIsProductMgtOpen(!isProductMgtOpen);
                }}
                className={isProductMgtOpen ? "active" : ""}
              >
                <i className="fas fa-box"></i>
                <p>Product Management</p>
                <span className="caret"></span>
              </a>
              {isProductMgtOpen && (
                <div className="collapse show" id="productManagement">
                  <ul className="nav nav-collapse" style={{ paddingLeft: "30px", listStyleType: "none" }}>
                    <li className={location.pathname === "/product/category" ? "active" : ""}>
                      <Link to="/product/category">
                        <span className="sub-item">Category</span>
                      </Link>
                    </li>
                    <li className={location.pathname === "/sub-category" ? "active" : ""}>
                      <Link to="/sub-category">
                        <span className="sub-item">Sub Category</span>
                      </Link>
                    </li>
                    <li className={location.pathname === "/product/create" ? "active" : ""}>
                      <Link to="/product/create">
                        <span className="sub-item">Products</span>
                      </Link>
                    </li>
                  </ul>
                </div>
              )}
            </li>

            {/* Communication & Feedback Dropdown */}
            <li className="nav-item">
              <a
                href="#!"
                onClick={(e) => {
                  e.preventDefault();
                  setIsCommFeedbackOpen(!isCommFeedbackOpen);
                }}
                className={isCommFeedbackOpen ? "active" : ""}
              >
                <i className="fas fa-comments"></i>
                <p>Communication & Feedback</p>
                <span className="caret"></span>
              </a>
              {isCommFeedbackOpen && (
                <div className="collapse show" id="commFeedbackManagement">
                  <ul className="nav nav-collapse" style={{ paddingLeft: "30px", listStyleType: "none" }}>
                    <li className={location.pathname === "/user/comments" ? "active" : ""}>
                      <Link to="/user/comments">
                        <span className="sub-item">Comments</span>
                      </Link>
                    </li>
                    <li className={location.pathname === "/user/feedback" ? "active" : ""}>
                      <Link to="/user/feedback">
                        <span className="sub-item">Feedbacks</span>
                      </Link>
                    </li>
                    <li className={location.pathname === "/user/announcement" ? "active" : ""}>
                      <Link to="/user/announcement">
                        <span className="sub-item">Announcements</span>
                      </Link>
                    </li>
                  </ul>
                </div>
              )}
            </li>

            {/* Content Management Dropdown */}
            <li className="nav-item">
              <a
                href="#!"
                onClick={(e) => {
                  e.preventDefault();
                  setIsContentMgtOpen(!isContentMgtOpen);
                }}
                className={isContentMgtOpen ? "active" : ""}
              >
                <i className="fas fa-file-alt"></i>
                <p>Content Management</p>
                <span className="caret"></span>
              </a>
              {isContentMgtOpen && (
                <div className="collapse show" id="contentManagement">
                  <ul className="nav nav-collapse" style={{ paddingLeft: "30px", listStyleType: "none" }}>
                    <li className={location.pathname === "/user/blogs" ? "active" : ""}>
                      <Link to="/user/blogs">
                        <span className="sub-item">Blogs</span>
                      </Link>
                    </li>
                    <li className={location.pathname === "/user/gallery" ? "active" : ""}>
                      <Link to="/user/gallery">
                        <span className="sub-item">Gallery</span>
                      </Link>
                    </li>
                    <li className={location.pathname === "/user/recipe/videos" ? "active" : ""}>
                      <Link to="/user/recipe/videos">
                        <span className="sub-item">Recipe Videos</span>
                      </Link>
                    </li>
                  </ul>
                </div>
              )}
            </li>

            {/* Add Recipe Management Dropdown */}
            <li className="nav-item">
              <a
                href="#!"
                onClick={(e) => {
                  e.preventDefault();
                  setIsRecipeOpen(!isRecipeOpen);
                }}
                className={isRecipeOpen ? "active" : ""}
              >
                <i className="fas fa-utensils"></i>
                <p>Recipe Management</p>
                <span className="caret"></span>
              </a>
              {isRecipeOpen && (
                <div className="collapse show" id="recipeManagement">
                  <ul className="nav nav-collapse" style={{ paddingLeft: "30px", listStyleType: "none" }}>
                    <li className={location.pathname === "/user/recipe-management/recipes" ? "active" : ""}>
                      <Link to="/user/recipe-management/recipes">
                        <span className="sub-item">Recipes</span>
                      </Link>
                    </li>
                    <li className={location.pathname === "/user/recipe-management/favorites" ? "active" : ""}>
                      <Link to="/user/recipe-management/favorites">
                        <span className="sub-item">Favorites</span>
                      </Link>
                    </li>
                    <li className={location.pathname === "/user/recipe-management/grocery" ? "active" : ""}>
                      <Link to="/user/recipe-management/grocery">
                        <span className="sub-item">Grocery Lists</span>
                      </Link>
                    </li>
                    <li className={location.pathname === "/user/recipe-management/health" ? "active" : ""}>
                      <Link to="/user/recipe-management/health">
                        <span className="sub-item">Health Profiles</span>
                      </Link>
                    </li>
                  </ul>
                </div>
              )}
            </li>
            
            {/* Add Recipe Masters Dropdown */}
            <li className="nav-item">
              <a
                href="#!"
                onClick={(e) => {
                  e.preventDefault();
                  setIsRecipeMastersOpen(!isRecipeMastersOpen);
                }}
                className={isRecipeMastersOpen ? "active" : ""}
              >
                <i className="fas fa-database"></i>
                <p>Recipe Masters</p>
                <span className="caret"></span>
              </a>
              {isRecipeMastersOpen && (
                <div className="collapse show" id="recipeMasters">
                  <ul className="nav nav-collapse" style={{ paddingLeft: "30px", listStyleType: "none" }}>
                    <li className={location.pathname === "/user/recipe-masters/benefits" ? "active" : ""}>
                      <Link to="/user/recipe-masters/benefits">
                        <span className="sub-item">Benefits</span>
                      </Link>
                    </li>
                    <li className={location.pathname === "/user/recipe-masters/diseases" ? "active" : ""}>
                      <Link to="/user/recipe-masters/diseases">
                        <span className="sub-item">Diseases</span>
                      </Link>
                    </li>
                    <li className={location.pathname === "/user/recipe-masters/nutrients" ? "active" : ""}>
                      <Link to="/user/recipe-masters/nutrients">
                        <span className="sub-item">Nutrients</span>
                      </Link>
                    </li>
                    <li className={location.pathname === "/user/recipe-masters/tags" ? "active" : ""}>
                      <Link to="/user/recipe-masters/tags">
                        <span className="sub-item">Tags</span>
                      </Link>
                    </li>
                    <li className={location.pathname === "/user/recipe-masters/categories" ? "active" : ""}>
                      <Link to="/user/recipe-masters/categories">
                        <span className="sub-item">Ingredient Categories</span>
                      </Link>
                    </li>
                    <li className={location.pathname === "/user/recipe-masters/ingredients" ? "active" : ""}>
                      <Link to="/user/recipe-masters/ingredients">
                        <span className="sub-item">Ingredients</span>
                      </Link>
                    </li>
                  </ul>
                </div>
              )}
            </li>

            {/* Logout */}
            <li
              className={`nav-item ${
                location.pathname === "/" ? "active" : ""
              }`}
            >
              <a href="/logout">
                <i className="fas fa-sign-out-alt"></i>
                <p>Logout</p>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;